export default __webpack_public_path__ + "static/media/lan-2.cd3d976d.jpg";